import React, { Component } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import { Link } from "react-router-dom";
import CustomHelmet from "../components/CustomHelmet";
export default class About extends Component {
  render() {
    return (
      <div>
        <Navbar search={true} props={this.props} user={this.props.user} />
        <div className="wrapper about_banner position-relative mh-new">
          <div className="overlay">
            <CustomHelmet page="About Us" />
            {/* <div className="container">
              <div className=" content search_bar_below align-items-center justify-content-center">
                <div className="row">
                  <div className="col-md-10 ml-0 col-sm-12 row">
                    <div className="col-6 p-0">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text bg-white bod-left-rad">
                            what
                          </div>
                        </div>
                        <input
                          type="text"
                          className="form-control border-left-0 form-control-lg input_1"
                          placeholder="Ex. Food, Plumber, Web Designer"
                        />
                      </div>
                    </div>
                    <div className="col-6 p-0">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text bg-white rounded-0">
                            where
                            <i
                              className="fa fa-map-marker ml-1"
                              aria-hidden="true"
                            ></i>
                          </div>
                        </div>
                        <input
                          type="text"
                          className="form-control border-left-0 form-control-lg input_2"
                          placeholder="Your City..."
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-12  d-flex  justify-content-center mt-md-0 mt-lg-0 mt-2">
                    <button className="btn btn-danger btn-lg addbtn">
                      <i className="fal fa-search"></i>
                    </button>{" "}
                  </div>
                </div>
              </div>
            </div> */}
            <div className="banner">
              <div className="content text-left mt-6 container">
                <h1>ABOUT HUBSQUARES</h1>
              </div>
            </div>
          </div>
        </div>

        <main className="container">
          <div className="navigation my-5">
            <p>
              <Link to="/" className="home">
                Home
              </Link>{" "}
              | <span> About Hubsquares</span>
            </p>
          </div>
          <div className="content pb-3">
            <div className="mb-5">
              <h3>Our Story</h3>
              <p>
                Hubsquares is a family business. Our family left Africa three
                years ago, and in that time, we have moved between cities and
                towns three times. One of the challenges we faced every time we
                moved was the ease to find and locate Local African Businesses
                nearby. The problem was not with their existence. These
                businesses were available but it took hours of searching through
                Google or using specific hashtags on Instagram to locate some of
                these businesses. Most times, you find these businesses by
                asking around or by referrals. We soon discovered that these
                businesses were closer to us than we realized but they were not
                visible enough.
              </p>
            </div>
            <div className="mb-5">
              <h3>Our Vision and Mission </h3>
              <p>
                Our Vision is to become the largest online platform for African
                owned businesses in the world. Hubsquares is an online platform
                like no other that creates visibility for African businesses,
                products and services, where everyone can search and connect
                with African businesses in diaspora easily.
              </p>
            </div>
            <div className="mb-5">
              <h3>Why we are better</h3>
              <p>
                Many services available use low quality and spam contents.
                Whilst this isn’t ethical, it could also do more harm to your
                brand than good. We use the best of technology on our website
                including security, taking into consideration SEO and speed.
              </p>
              <p>
                We mostly rewrite your contents to make sure it fits into the
                proper domain for maximum availability on Google search pages.
                We also research and select the best keywords for your page
                which makes your business more easy to find on the web.
              </p>
              <p>
                Because we value quality, we go the extra mile to ensure that
                all businesses listed on our business directory are verified and
                authentic. We also provide you a means of allowing your
                customers contact you directly via your business page.
              </p>
            </div>
            <div className="mb-5">
              <h3>Ratings</h3>
              <p>
                There is nothing more rewarding than showcasing your expertise
                to the world. This is why our business finder directory allows
                your customers to leave reviews about your services and
                businesses on your business page. You know what they say, if
                you’ve got it, flaunt it!
              </p>
            </div>
            <div className="mb-5">
              <h3>Affordable</h3>
              <p>
                We feel that our service is both affordable with a fantastic
                value. What’s more, it’s also user friendly. Depending on your
                budget, you can start out comfortably as a free user forever or
                migrate for a small fee to manage multiple businesses and
                services using one account.
              </p>
            </div>
            <div className="mb-5">
              <h3>More Questions?</h3>
              <p>
                Our list of benefits goes on and you can find out yourself by
                business your business now. For other questions about us and our
                service feel free to read over our privacy policy or reach out
                to us via the form on our contact us page.
              </p>
            </div>
          </div>
          <div className="position-relative mb-5">
            <button
              className="text-white addbtn btn-danger btn  position-absolute bg-red"
              style={{
                right: 0,
              }}
              onClick={() => window.scrollTo(0, 0)}
            >
              {/* <i class="fa fa-caret-up" aria-hidden="true"></i> */}
              Back to top
            </button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}
